export const VARIANT = {
    HORIZONTAL: 'horizontal',
    COLLECTION: 'collection',
};

type VariantKeys = keyof typeof VARIANT;
export type VariantValues = (typeof VARIANT)[VariantKeys];